import React from "react";

import ModeratorCommentList from "@components/Screen/ModeratorComments";
import { url_reverse } from "@components/Utils";

export default function ModeratorComments({ gameId, header }) {
    const apiUrl = url_reverse("api:game:moderator_comments", { game_id: gameId });
    return <ModeratorCommentList header={header} apiUrl={apiUrl} />;
}
